"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePath = void 0;
exports.addQueryParams = addQueryParams;
const object_1 = require("./object");
/**
 * `:`로 구분되는 path의 parameter를 실제 값으로 변환한 path를 만듭니다.
 * @param path `/some/path/:id` 형식의 path
 * @param params {id:"example_id"} 형식의 parameters
 */
const generatePath = (path, params) => {
    let result = path;
    (0, object_1.objectKeys)(params).forEach(key => {
        result = result.replace(`:${key}`, params[key]);
    });
    return result;
};
exports.generatePath = generatePath;
/**
 * Adds or updates multiple query parameters to a given URL.
 *
 * This function takes an existing URL and an object of key-value pairs representing
 * query parameters, and appends or updates them in the URL's query string.
 *
 * @param {string} url - The base URL to which query parameters will be added or updated.
 * @param {Record<string, string>} params - An object containing key-value pairs representing the query parameters to be added or updated.
 *
 * @returns {string} The updated URL with the new query parameters.
 *
 * @example
 * ```typescript
 * const originalUrl = "https://example.com/path?existingParam=value";
 * const newParams = { newParam: "newValue", anotherParam: "anotherValue" };
 * const updatedUrl = addQueryParams(originalUrl, newParams);
 * console.log(updatedUrl);
 * // Output: "https://example.com/path?existingParam=value&newParam=newValue&anotherParam=anotherValue"
 * ```
 */
function addQueryParams(url, params) {
    const updatedUrl = new URL(url);
    Object.keys(params).forEach(key => {
        updatedUrl.searchParams.set(key, params[key]);
    });
    return updatedUrl.toString();
}
